import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Form,
  Input,
  Button,
  Toast,
  NoticeBar,
} from 'antd-mobile';
import {
  FrownOutline
} from 'antd-mobile-icons';
import api from "../../../api";
import "./style.less";

const BindMobile = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [error, setError] = useState('');
  const [extra, setExtra] = useState('发送验证码');
  const [countdown, setCountdown] = useState(false);


  const doSetError = (msg) => {
    setError(msg)
    setTimeout(() => {
      setError('')
    }, 2000);
  }

  const validateMobile = (mobile) => {
    const mobileReg = new RegExp('^(1)\\d{10}$')
    const mobileValid = mobileReg.test('' + mobile)
    if (!mobileValid) {
      doSetError('手机号格式不正确')
    }
    return mobileValid
  }

  const validateCaptcha = (captcha) => {
    const captchaReg = new RegExp('^\\d{6}$')
    const captchaValid = captchaReg.test('' + captcha)
    if (!captchaValid) {
      doSetError('验证码不正确')
    }
    return captchaValid
  }

  const onSubmit = () => {
    const values = form.getFieldsValue()

    if (!validateMobile(values.mobile)) {
      return
    }

    if (!validateCaptcha(values.captcha)) {
      return
    }

    api.alipayBindMobile(values).then(res => {
      if (!res.data) {
        doSetError('绑定失败, 请稍后重试')
      }

      if (res.data?.code === 0) {
        Toast.show({ content: '绑定成功', duration: 500, position: 'top' })
        navigate("/home")
      } else {
        doSetError(res.data?.message)
      }
    })
  }

  const handleSendCaptcha = () => {
    // 正在倒计时时,点击发送验证码不起作用
    if (countdown) {
      return
    }

    const values = form.getFieldsValue()

    if (!validateMobile(values.mobile)) {
      return
    }

    api.sendSmsCode({ mobile: values.mobile }).then((res) => {
      if (!res.data) {
        doSetError('发送失败，请稍后再试')
        return
      }

      if (res.data.code !== 0) {
        doSetError(res.data.message)
        return
      }

      Toast.show({ content: res.data.message, duration: 1000, position: 'top' })

      // 开始倒计时
      setCountdown(true)
      setExtra(60)
    })
  }

  useEffect(() => {
    if (extra && typeof extra === 'number') {

      // 倒计时结束, 恢复发送按钮
      if (extra <= 1) {
        setCountdown(false)
        setExtra('发送验证码')
        return
      }

      setTimeout(() => {
        setExtra(extra - 1)
      }, 1000);
    }
  }, [extra])


  return (
    <div>
      <div className="error-wrapper">
        {error ?
          <NoticeBar
            icon={<FrownOutline />}
            content={error}
            color='error'
          /> : undefined
        }
      </div>

      <Form
        form={form}
        layout='horizontal'
        footer={
          <Button block color='primary' size='large' onClick={onSubmit}>
            绑定
          </Button>
        }
      >
        <Form.Header>绑定手机号</Form.Header>
        <Form.Item
          name='mobile'
          label='手机号'
          rules={[
            { required: true, message: '手机号不能为空' }
          ]}
        >
          <Input
            placeholder='手机号'
            type='text'
            clearable={true}
          />
        </Form.Item>
        <Form.Item
          name='captcha'
          label='短信验证码'
          rules={[
            { required: true, message: '验证码不能为空' }
          ]}
          extra={
            <div className='extraPart'>
              <a onClick={() => handleSendCaptcha()}>
                {typeof extra === 'number' ? '' + extra + 's' : extra}
              </a>
            </div>
          }
        >
          <Input
            placeholder='验证码'
            type='text'
            clearable={true}
          />
        </Form.Item>
      </Form>
    </div>
  )
}

export default BindMobile;